import HeroSection from "../components/sections/HeroSections.js";
import AboutSection from "../components/sections/AboutSection";
import ServiceSection from "../components/sections/ServiceSection";
import WhoWeAreSection from "../components/sections/WhoWeAreSection.js";
import FlowSection from "../components/sections/FlowSection.js";
import ProjectsSection from "../components/sections/ProjectsSection.js";
import PriceSection from "../components/sections/PriceSection.js";
import ContactsSection from "../components/sections/ContactsSection.js";

const SectionRenderer = ({ sections }) => {
  if (!sections || !Array.isArray(sections)) return null;

  return (
    <>
      {sections.map((section, index) => {
        switch (section.__component) {
          case "sections.hero-section":
            return <HeroSection key={index} data={section} />;
          case "sections.about-section":
            return (
              <AboutSection key={index} data={section} anchorId={"about"} />
            );
          case "sections.service-section":
            return (
              <ServiceSection key={index} data={section} anchorId={"service"} />
            );
          case "sections.who-are-we-section":
            return (
              <WhoWeAreSection key={index} data={section} anchorId={"who"} />
            );
          case "sections.flow-section":
            return <FlowSection key={index} data={section} anchorId={"flow"} />;
          case "sections.projects-section":
            return (
              <ProjectsSection
                key={index}
                data={section}
                anchorId={"projects"}
              />
            );
          case "sections.price-section":
            return (
              <PriceSection key={index} data={section} anchorId={"prices"} />
            );
          case "sections.contacts-section":
            return (
              <ContactsSection
                key={index}
                data={section}
                anchorId={"contacts"}
              />
            );
          default:
            return null;
        }
      })}
    </>
  );
};

export default SectionRenderer;
